var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/components/columns-area.tsx";
import React from 'react';
import { Layout } from '../../../components/ui';

const ColumnsArea = props => {
  const {
    children
  } = props;
  const layout = props.layout || {
    LEFT: null,
    RIGHT: null
  };
  return /*#__PURE__*/React.createElement(Layout, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Layout.Sidebar, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 7
    }
  }, layout.LEFT), /*#__PURE__*/React.createElement(Layout.Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 7
    }
  }, children), /*#__PURE__*/React.createElement(Layout.Aside, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }, layout.RIGHT));
};

export default ColumnsArea;